export default __webpack_public_path__ + "static/media/evtech.204a12d7.png";